export default __webpack_public_path__ + "images/fede90e1b0ba7f692fd98462792d9b3e.png";